import React, { useEffect, useRef } from 'react';

// Nested React components receive no AngularJS services in props, so the shared loader
// is compiled through the injector that the hybrid bootstrap attaches to document.body.
const angularJsInjector = () => window.angular?.element(document.body).injector();

const isRedesignEnabled = injector => !!injector?.get('$rootScope').isLegacyThemeRedesignEnabled?.();

const RedesignedLoader = ({ injector }) => {
  const hostRef = useRef(null);

  useEffect(() => {
    const scope = injector.get('$rootScope').$new();
    const loader = injector.get('$compile')('<lmapp-loader [overlay]="true"></lmapp-loader>')(scope);
    hostRef.current.appendChild(loader[0]);
    scope.$applyAsync();

    return () => {
      loader.remove();
      scope.$destroy();
    };
  }, [injector]);

  return <div ref={hostRef} />;
};

const LegacyLoader = () => {
  const createSpinner = () => {
    const spinnerList = [];
    for (let i = 0; i < 12; i++) {
      spinnerList.push(
        <div
          key={`${i}-spinner`}
          className="spinner-item"
          style={{
            animation: `1s linear 0s infinite normal none running opacity-100-25-${i}-12`,
          }}>
          <div
            className="spinner-item-content"
            style={{
              transform: `rotate(${i * 30}deg) translate(10px, 0px)`,
            }}
          />
        </div>
      );
    }
    return spinnerList;
  };

  return (
    <div className="loader">
      <div className="spinner" role="progressbar">
        {createSpinner()}
      </div>
    </div>
  );
};

const Loader = () => {
  const injector = angularJsInjector();

  return isRedesignEnabled(injector) ? <RedesignedLoader injector={injector} /> : <LegacyLoader />;
};

export default Loader;
